import api from "./api"

const getSessionHeaders = () => {
  const headers = {}

  const userId = localStorage.getItem("kongosys_user_id")
  const role = localStorage.getItem("kongosys_role")
  const companyId = localStorage.getItem("kongosys_company_id")
  const organizationId = localStorage.getItem("kongosys_organization_id")
  const organizationCode = localStorage.getItem("kongosys_organization_code")
  const storeId = localStorage.getItem("kongosys_store_id")
  const warehouseId = localStorage.getItem("kongosys_warehouse_id")

  if (userId) headers["X-User-Id"] = userId
  if (role) headers["X-Role"] = role
  if (companyId) headers["X-Company-Id"] = companyId
  if (organizationId) headers["X-Organization-Id"] = organizationId
  if (organizationCode) headers["X-Organization-Code"] = organizationCode
  if (storeId) headers["X-Store-Id"] = storeId
  if (warehouseId) headers["X-Warehouse-Id"] = warehouseId

  return headers
}

const cleanParams = (params = {}) => {
  const result = {}

  if (params.store_id) result.store_id = params.store_id
  if (params.expense_type) result.expense_type = params.expense_type
  if (params.status) result.status = params.status
  if (params.date_from) result.date_from = params.date_from
  if (params.date_to) result.date_to = params.date_to

  return result
}

export const getExpenses = async (params = {}) => {
  const response = await api.get("/expenses", {
    params: cleanParams(params),
    headers: getSessionHeaders(),
  })

  return response.data
}

export const getExpenseById = async (expenseId) => {
  const response = await api.get(`/expenses/${expenseId}`, {
    headers: getSessionHeaders(),
  })

  return response.data
}

export const getExpenseFormData = async () => {
  const response = await api.get("/expenses/form-data", {
    headers: getSessionHeaders(),
  })

  return response.data
}

export const createExpense = async (payload) => {
  const response = await api.post("/expenses", payload, {
    headers: getSessionHeaders(),
  })

  return response.data
}

export const updateExpense = async (expenseId, payload) => {
  const response = await api.put(`/expenses/${expenseId}`, payload, {
    headers: getSessionHeaders(),
  })

  return response.data
}

export const deleteExpense = async (expenseId) => {
  const response = await api.delete(`/expenses/${expenseId}`, {
    headers: getSessionHeaders(),
  })

  return response.data
}